export const MINUTE_MILLISECONDS = 60 * 1000
export const HOUR_MILLISECONDS = 60 * 60 * 1000
export const TWENTY_FOUR_HOURS_MILLISECONDS = 24 * HOUR_MILLISECONDS
export const TEN_MINUTES_MILLISECONDS = 10 * MINUTE_MILLISECONDS
export const TEN_DAYS_MILLISECONDS = 10 * TWENTY_FOUR_HOURS_MILLISECONDS
